module.exports = __webpack_public_path__ + "static/sidemail-trial-61271f1ae2de0d17f32722350a5b6148.png";